import axios from 'axios';

const API_BASE_URL = process.env.REACT_APP_API_URL || 'https://localhost:7271/api';

// Types
export interface TithePaymentDto {
  id: number;
  amount: number;
  paymentDate: string;
  notes?: string;
  createdAt: string;
  updatedAt: string;
}

export interface CreateTithePaymentDto {
  amount: number;
  paymentDate: string;
  notes?: string;
}

export type UpdateTithePaymentDto = CreateTithePaymentDto;

// סיכום מעשרות לטווח תאריכים נבחר (ללא טווח = כל הנתונים).
// בסיס המעשר = תשלומי לקוחות − הוצאות + תשלומים מיוחדים + הנחות.
export interface TitheSummaryDto {
  clientPayments: number;
  expenses: number;
  discounts: number;
  specialPayments: number;
  netTotalIncome: number;
  titheToPay: number;
  amountPaid: number;
  amountRemaining: number;
}

const BASE = `${API_BASE_URL}/tithes`;

export const tithesApi = {
  // ללא טווח = כל הנתונים
  getSummary: async (dateFrom?: string, dateTo?: string): Promise<TitheSummaryDto> => {
    const response = await axios.get<TitheSummaryDto>(`${BASE}/summary`, {
      params: { dateFrom: dateFrom || undefined, dateTo: dateTo || undefined },
    });
    return response.data;
  },

  listPayments: async (dateFrom?: string, dateTo?: string): Promise<TithePaymentDto[]> => {
    const response = await axios.get<TithePaymentDto[]>(`${BASE}/payments`, {
      params: { dateFrom: dateFrom || undefined, dateTo: dateTo || undefined },
    });
    return response.data;
  },

  create: async (dto: CreateTithePaymentDto): Promise<TithePaymentDto> => {
    const response = await axios.post<TithePaymentDto>(`${BASE}/payments`, dto);
    return response.data;
  },

  update: async (id: number, dto: UpdateTithePaymentDto): Promise<TithePaymentDto> => {
    const response = await axios.put<TithePaymentDto>(`${BASE}/payments/${id}`, dto);
    return response.data;
  },

  remove: async (id: number): Promise<void> => {
    await axios.delete(`${BASE}/payments/${id}`);
  },
};

// Helpers (פורמט he-IL, תואם שאר השירותים)
export const formatCurrency = (amount: number | undefined | null): string => {
  if (amount === undefined || amount === null) return '-';
  return `₪${amount.toLocaleString('he-IL', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;
};

export const formatDate = (dateString?: string): string => {
  if (!dateString) return '-';
  const date = new Date(dateString);
  return date.toLocaleDateString('he-IL', { day: '2-digit', month: '2-digit', year: 'numeric' });
};
